"use client";

import { X } from "lucide-react";
import { markPopupDismissed, popupDomId, type PublicPopup } from "@/lib/popups";

/**
 * Sunucuda basılan şerit de istemci popup'ı da aynı düğmeyi kullanır: kapatma
 * kaydı yazılır ve öğe DOM'da gizlenir (sunucu bileşeni durum tutamaz).
 */
export default function PopupCloseButton({ popup }: { popup: Pick<PublicPopup, "id" | "display_frequency" | "closeable"> }) {
  if (!popup.closeable) return null;
  return (
    <button
      type="button"
      onClick={() => {
        markPopupDismissed(popup);
        const el = document.getElementById(popupDomId(popup.id));
        if (el) el.hidden = true;
      }}
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md opacity-70 transition hover:bg-black/10 hover:opacity-100"
      aria-label="Kapat"
    >
      <X className="h-4 w-4" aria-hidden />
    </button>
  );
}
